document.addEventListener('quizKitAddToCartSuccess', function () {
  // Fetch updated cart
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Trigger Focal’s built-in drawer refresh event
      document.documentElement.dispatchEvent(new CustomEvent(
        'cart:refresh',
        { bubbles: true, detail: { cart, openMiniCart: true } }
      ));
    })
    .catch(console.error);
}, false);